import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";

import { leftMenuItems } from "../utils/MenuDefinition";
import Audience from "../utils/Audience";
import SETTINGS from "../globals";

function LeftMenu() {
  // reference to the AuthManager
  const authManager = useAuth();

  // reference to the navigator
  const navigate = useNavigate();

  // we need to identify current location for menu highlighting
  const location = useLocation();
  // extract section from location
  const section = location.pathname.split("/")[1];

  return (
    <div className="z-40 w-56 h-screen overflow-y-auto bg-slate-600 text-sm float-start fixed border-r px-2">
      <div className="py-2 overflow-y-auto">
        <ul className="font-light">
          {leftMenuItems
            // display menu elements according to the user's role
            .filter((item) => {
              return authManager.isAdmin()
                ? // the administrator can access all menus
                  true
                : // non-administrators can access only specific audiences
                  item.audience === Audience.AUTHENTICATED;
            })
            .map((item, index) => {
              if (item.label == "admin_separator") {
                return (
                  <li key="separator" className="left-menu-separator">
                    Administrator Sections
                  </li>
                );
              }
              // current menu should be highlighted
              var menuCSS =
                "flex items-center p-2 text-slate-100 hover:bg-gray-400 group pl-4 cursor-pointer";

              if (section == item.identifier) {
                menuCSS += " bg-gray-400";
              }

              return (
                <li key={item.identifier + "_" + index} className="py-1">
                  <a
                    onClick={() =>
                      navigate(SETTINGS.get_path({ section: item.identifier }))
                    }
                    className={menuCSS}
                  >
                    {item.icon}
                    <span className="ms-3">{item.label}</span>
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}

export default LeftMenu;
